


























import { ADMIN_TYPE } from "@/common/constant";
import Product from "@/model/product";
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const cartStore = namespace("Cart");
const authStore = namespace("Auth");

@Component({
  name: "listProduction",
})
export default class ListProduction extends Vue {
  @Prop() product: Product;

  @cartStore.Action
  add!: (payload: { production: Product; quantity: number }) => void;
  @authStore.Getter
  getUserType!: string;

  public quantity = 1;

  public imageDefault = "/img/noimage.png";

  get isAdmin() {
    return this.getUserType == ADMIN_TYPE;
  }

  select() {
    this.$emit("select", this.product);
  }
}
